import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/PickedUpReservation.svg'


const _hoisted_1 = ["type"]
const _hoisted_2 = {
  key: 0,
  class: "img",
  src: _imports_0,
  alt: "Picked Up DeliveryHistory"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass({
      button: true,
      logIn: _ctx.variant === 'logIn',
      filled: _ctx.variant === 'filled',
      bordered: _ctx.variant === 'bordered',
      wideBordered: _ctx.variant === 'wideBordered',
      borderedBackground: _ctx.variant === 'borderedBackground',
      borderedInactive: _ctx.variant === 'borderedInactive',
      notBordered: _ctx.variant === 'notBordered',
      redButton: _ctx.variant === 'redButton',
      yellowButton: _ctx.variant === 'yellowButton',
      disabled: _ctx.variant === 'disabled',
      disabledBackground: _ctx.variant === 'disabledBackground',
      disabledLong: _ctx.variant === 'disabledLong',
      disabledNotBordered: _ctx.variant === 'disabledNotBordered',
      search: _ctx.variant === 'search',
      redBordered: _ctx.variant === 'redBordered',
      redBorderedBackground: _ctx.variant === 'redBorderedBackground',
      blackButton: _ctx.variant === 'blackButton'
    }),
    type: _ctx.type || 'button'
  }, [
    _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
    (_ctx.$route.name === 'DeliveryHistory' && _ctx.title === _ctx.$t('pickedUp'))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}